import request from '@/utils/request'

export function login (username, password) {
  return request({
    url: 'login',
    method: 'post',
    data: { username, password }
  })
}

export function logout () {
  return request({
    url: 'logout',
    method: 'get'
  })
}

export function addUser (data) {
  return request({
    url: '/api/users',
    method: 'post',
    data
  })
}

export function editUser (data) {
  return request({
    url: '/api/users',
    method: 'put',
    data
  })
}

export function deleteUser (uuid) {
  return request({
    url: '/api/users/' + uuid,
    method: 'delete'
  })
}

export function updatePw (data) {
  return request({
    url: '/api/users/updatePass',
    method: 'post',
    data
  })
}
